import React, { useEffect, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { StopTravelStatus } from '../../../redux/type';
import { useSelector } from 'react-redux';
import { RootState } from '@/index';
import { formatTimetoString } from '@/utils';
interface Props {
  departTimestamp: number;
  globalMileage: number;
  status: StopTravelStatus;
}

const ContinueTime = React.memo((props: Props) => {
  const { departTimestamp, status, globalMileage } = props;
  const [continueTime, setContinueTime] = useState('');
  const departTime: number = new Date(departTimestamp).getTime();
  let time = new Date().getTime() - departTime;
  const vehicleRealTimeInfo = useSelector(
    (state: RootState) => state.singleVehiclePageInfo.vehicleRealTimeInfo,
  );
  const { currentStopFinishedMileage } = vehicleRealTimeInfo;
  useEffect(() => {
    let timeInterval = undefined;
    if (status === StopTravelStatus.START) {
      timeInterval = setInterval(() => {
        time = time + 1000;
        const timeLong1 = formatTimetoString(time);
        setContinueTime(timeLong1);
      }, 1000);
    } else {
      clearInterval(timeInterval);
    }
  }, [status]);

  return (
    <div className='time'>
      <img
        src={require('../../../assets/img/views/single/progress-car.png')}
      ></img>
      {continueTime} &nbsp;&nbsp;
      {(currentStopFinishedMileage &&
        (currentStopFinishedMileage / 1000).toFixed(2)) ||
        '0.00'}
      /{(globalMileage && (globalMileage / 1000).toFixed(2)) || '0.00'}km &nbsp;
    </div>
  );
});
ContinueTime.displayName = 'ContinueTime';
export default React.memo(ContinueTime);
